module.exports = __webpack_public_path__ + "static/media/cafe_croissant.35b21ac7.mp3";